export const maxLengthHelper = (value: string, maxLength: number) => {
  return {
    helperText: `${value.length}/${maxLength}`,
    inputProps: { maxLength: maxLength }
  };
};
